"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Renderer {
    constructor(L, item, args) {
        this.L = L;
        this.item = item;
        this.args = args;
    }
    async getDocumentTemplateData() {
        throw new Error('getDocumentTemplateData is not implemented!');
    }
}
exports.default = Renderer;
//# sourceMappingURL=../../../src/classes/Renderer.js.map